import React, { FC, forwardRef, useContext } from 'react'
import { connect } from 'react-redux';
import { Button } from 'semantic-ui-react';

import { IdentityEnum, PreChekInStepEnum } from '../../../common/types/checkin';
import GlobalContext from '../../../contexts/GlobalContext';
import { RootDispatch, RootState } from '../../../store';

const mapProps = (state: RootState) => ({
  identity: state.checkin.stepperForm.identity
})

const mapDispatch = (dispatch: RootDispatch) => ({
  handleStepperForm: dispatch.checkin.handleStepperForm
})

type Props = {
  ref?: any
} & ReturnType<typeof mapProps> & ReturnType<typeof mapDispatch>

const Identity: FC<Props> = forwardRef(({
  identity, handleStepperForm
}, ref) => {
  const [globalContext] = useContext(GlobalContext) as any

  return (
    <div style={{ textAlign: 'center' }}>
      <p>{globalContext.translations.modalCheckInIdentityTitle} ?</p>
      <Button.Group size="massive">
        <Button
          type="button"
          onClick={() => handleStepperForm({identity: IdentityEnum.ResidentBase, step: PreChekInStepEnum.PrincipalInfos}) }
          color={identity === IdentityEnum.ResidentBase ? 'blue' : null}
        >
          {globalContext.translations.modalCheckInIdentityMe}
        </Button>
        <Button.Or text={globalContext.translations.modalCheckInIdentityOr} />
        <Button
          type="button"
          onClick={() => handleStepperForm({identity: IdentityEnum.RoomingList, step: PreChekInStepEnum.PrincipalInfos})}
          color={identity === IdentityEnum.RoomingList ? 'blue' : null}
        >
          {globalContext.translations.modalCheckInIdentityOther}
        </Button>
      </Button.Group>
    </div>
  )
})

export default connect(mapProps, mapDispatch)(Identity)